export const about = {
  seo: {
    title: '会社概要 | LensBank プロ機材レンタル',
    description: '10年以上のプロ機材レンタル経験、金馬奨との信頼のブランド。台日撮影協力、プロチームサポートを提供し、映像制作の最良のパートナーです。',
    keywords: 'LensBank,機材レンタル会社,台日協力,金馬奨,プロチーム'
  },
  hero: {
    title: 'LensBankについて',
    subtitle: '10年以上の専門経験、信頼できる映像制作パートナー'
  },
  story: {
    title: '私たちのストーリー',
    content: 'LensBankは2008年に設立され、プロ撮影機材レンタルサービスの提供に注力しています。10年以上にわたり、豊富な経験を積み重ね、金馬奨などの重要な映像イベントと長期的な協力関係を築いてきました。機材の提供だけでなく、専門的な技術サポートとコンサルティングサービスも提供し、映像クリエイターの最も信頼できるパートナーとなっています。'
  },
  milestones: {
    title: '重要なマイルストーン',
    items: [
      {
        year: '2008',
        title: '会社設立',
        desc: '台中に最初の店舗を開設し、プロ機材レンタルサービスを開始'
      },
      {
        year: '2010',
        title: '多拠点展開',
        desc: '台中、台南に拠点を設立し、サービス範囲を台湾全土に拡大'
      },
      {
        year: '2013',
        title: '金馬映画祭協力',
        desc: '金馬映画祭の協力パートナーとなり、長期的な映画祭協力関係を開始'
      },
      {
        year: '2016',
        title: '台日協力',
        desc: '台日撮影協力サービスを確立し、国境を越えた撮影の全面サポートを提供'
      },
      {
        year: '2023',
        title: 'Urentサービス',
        desc: 'Urent寄託レンタルサービスを開始し、遊休機材に価値を創出'
      }
    ]
  },
  values: {
    title: '私たちの価値観',
    items: [
      {
        title: 'プロの品質',
        desc: 'すべての機材を厳格に管理し、最高の使用状態を確保'
      },
      {
        title: '顧客第一',
        desc: '専門的なコンサルティングと技術サポートを提供し、撮影の課題を解決'
      },
      {
        title: '革新的サービス',
        desc: '新しいサービスを継続的に開発し、多様な撮影ニーズに対応'
      },
      {
        title: '信頼のパートナー',
        desc: '顧客と長期的な協力関係を築き、共に成長'
      }
    ]
  },
  team: {
    title: 'プロフェッショナルチーム',
    desc: '経験豊富な専門チームを擁し、機材管理の専門家、技術サポートスタッフ、撮影コーディネーターが在籍しています。チームメンバーは豊富な映像制作経験を持ち、最も専門的なアドバイスとサポートを提供できます。'
  },
  capabilities: {
    title: 'サービス能力',
    items: [
      '1,000点以上のプロ撮影機材',
      '4つのサービス拠点（店舗 + 倉庫）',
      '台日国境を越えた撮影協力',
      '専門技術サポートチーム',
      'スタッフ派遣撮影サービス',
      'カスタマイズ撮影ソリューション'
    ]
  }
};